import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import homeStyle from './Home.module.scss';
import QuickAbout from '../../components/sections/quickAbout/QuickAbout';
import AutoPlayCarousle from '../../components/autoPlayCarousle/AutoPlayCarousle';
import MyJourney from '../../components/sections/myJourney/MyJourney';
import Stack from '../../components/sections/stack/Stack';
import Contact from '../../components/sections/contact/Contact';
import ProjectCard from '../../components/projectCard/ProjectCard';
import SectionHeading from '../../components/elements/sectionHeading/SectionHeading';
import Reveal from '../../components/elements/reveal/Reveal';
import IButton from '../../components/elements/iButton/IButton';
import { featuredProjects } from '../../data/projects';
import { RoutesUrl } from '../../router/RouterUrls';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const Home = observer(() => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <>
            <QuickAbout />
            <AutoPlayCarousle />
            <MyJourney />
            <Stack />

            <section className={homeStyle.work}>
                <div className={homeStyle.inner}>
                    <SectionHeading
                        eyebrow={t('projects.eyebrow')}
                        title={t('projects.selectedTitle')}
                        description={t('projects.selectedDescription')}
                        action={
                            <IButton
                                title={t('projects.viewAll')}
                                onClick={() => navigate(RoutesUrl.projects)}
                                variant='ghost'
                                icon={<ArrowForwardIcon />}
                            />
                        }
                    />

                    <div className={homeStyle.grid}>
                        {featuredProjects.map((project, i) => (
                            <Reveal key={project.name} delay={i * 90} className={homeStyle.cell}>
                                <ProjectCard project={project} />
                            </Reveal>
                        ))}
                    </div>
                </div>
            </section>

            <Contact />
        </>
    );
});

export default Home;
